var _path, _path2, _path3, _g, _g2, _path4, _g3, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventBoardPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 141,
    viewBox: "0 0 111 141",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2916 56.3051C94.9817 56.2338 94.6564 56.3016 94.4013 56.4912L68.5283 75.7493C68.1062 76.0636 67.9709 76.6359 68.207 77.1062L69.3049 79.2907C69.324 79.3287 69.3462 79.3647 69.3691 79.3996L95.2567 60.1306C95.5118 59.9408 95.8371 59.8723 96.147 59.9435L127.994 67.2709C128.075 67.0864 128.106 66.877 128.072 66.6638L127.724 64.4641C127.655 64.0272 127.328 63.6759 126.897 63.5766L95.2916 56.3051Z",
    fill: "url(#paint0_linear_7038_16864)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.088 87.2382C101.833 87.4282 101.507 87.4965 101.197 87.4251L70.3957 80.3356C69.4953 80.1284 69.2498 78.9623 69.99 78.4096L94.7969 59.8867C95.0482 59.699 95.3685 59.6293 95.675 59.6956L126.987 66.4655C127.898 66.6623 128.153 67.8396 127.406 68.3957L102.088 87.2382Z",
    fill: "url(#paint1_linear_7038_16864)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.234 87.1936C101.978 87.3835 101.652 87.4518 101.342 87.3805L70.2159 80.2158C69.8911 80.1411 69.6182 79.9214 69.4767 79.6197L68.4594 77.4485C68.2669 77.0375 68.3575 76.5813 68.63 76.2715L100.541 83.6163C100.851 83.6875 101.176 83.6194 101.431 83.4297L126.958 64.433C127.374 64.5196 127.719 64.8485 127.803 65.2929L128.154 67.1416C128.232 67.5495 128.069 67.9659 127.736 68.2138L102.234 87.1936Z",
    fill: "url(#paint2_linear_7038_16864)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_7038_16864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5755 71.2632L93.0533 86.3412L61.1388 97.7572L38.5731 71.9429L64.2537 69.349C66.8449 69.0873 69.4439 69.7667 71.5755 71.2632Z",
    fill: "url(#paint3_linear_7038_16864)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_7038_16864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5748 72.2098C69.4433 70.7135 66.8446 70.0332 64.2535 70.2948L39.7183 72.7745L38.5725 71.9461L64.2532 69.3518C66.8442 69.0901 69.4429 69.7696 71.5744 71.2658L93.0525 86.3441L91.8926 86.4716L71.5748 72.2098Z",
    fill: "url(#paint4_linear_7038_16864)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1502 76.3704C78.0654 75.2294 79.906 75.9262 79.8362 77.3872L79.7453 79.2907C79.7141 79.9441 80.1071 80.5433 80.7189 80.7749L82.5011 81.4496C83.8691 81.9675 83.7752 83.9333 82.364 84.3184L80.5256 84.8201C79.8946 84.9924 79.4462 85.5514 79.4149 86.2048L79.324 88.1082C79.2542 89.5693 77.3556 90.0874 76.5532 88.8644L75.508 87.271C75.1492 86.724 74.479 86.4703 73.8479 86.6425L72.0095 87.1442C70.5984 87.5293 69.5189 85.8837 70.4341 84.7428L71.6265 83.2563C72.0359 82.746 72.0701 82.0302 71.7113 81.4833L70.666 79.8898C69.8637 78.6668 71.0952 77.1316 72.4631 77.6495L74.2453 78.3242C74.8571 78.5558 75.5484 78.3671 75.9578 77.8569L77.1502 76.3704Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 7.21289,
    width: 120.915,
    height: 93.5764
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0.5px)",
      clipPath: "url(#bgblur_0_7038_16864_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_7038_16864)",
    "data-figma-bg-blur-radius": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 8.21289C20.6154 27.6629 49.0129 81.6413 45.6781 86.8946L86.2247 99.7893C83.071 81.134 101.658 50.3176 119.915 12.1639L1 8.21289Z",
    fill: "url(#paint5_linear_7038_16864)",
    fillOpacity: 0.48
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.615 107.221C86.3883 107.955 85.7606 108.495 85.0003 108.609L57.8095 112.684C57.2572 112.767 56.6955 112.615 56.2602 112.265L35.5981 95.6582C35.0323 95.2035 34.7573 94.4779 34.8796 93.7624L38.6172 71.8909L63.3594 89.122L93.0764 86.279L86.615 107.221Z",
    fill: "url(#paint6_linear_7038_16864)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8401 50.462C49.0231 49.0107 50.9563 48.6416 51.6612 49.9232L53.0604 52.4673C53.3757 53.0404 54.0242 53.3454 54.6667 53.2227L57.5186 52.6781C58.9554 52.4037 59.9038 54.1282 58.9028 55.1947L56.9156 57.3116C56.4679 57.7885 56.3783 58.4995 56.6935 59.0727L58.0928 61.6167C58.7977 62.8983 57.4507 64.3333 56.1271 63.7107L53.4997 62.475C52.9078 62.1966 52.2039 62.3311 51.7562 62.808L49.7691 64.9249C48.768 65.9914 46.9871 65.1538 47.1701 63.7026L47.5334 60.8219C47.6153 60.1729 47.2699 59.545 46.678 59.2666L44.0506 58.0309C42.727 57.4084 42.9733 55.4558 44.41 55.1814L47.2619 54.6368C47.9045 54.5141 48.3949 53.9916 48.4768 53.3426L48.8401 50.462Z",
    fill: "#D7E6F3",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4185 35.1457C90.3338 34.0047 92.1744 34.7015 92.1046 36.1626L91.9819 38.7305C91.9507 39.3839 92.3437 39.9831 92.9555 40.2147L95.3599 41.1249C96.7278 41.6428 96.6339 43.6086 95.2228 43.9937L92.7426 44.6706C92.1116 44.8428 91.6632 45.4018 91.6319 46.0552L91.5093 48.6231C91.4395 50.0841 89.5408 50.6023 88.7385 49.3792L87.3284 47.2296C86.9696 46.6827 86.2994 46.429 85.6683 46.6012L83.1882 47.278C81.777 47.6631 80.6975 46.0175 81.6128 44.8766L83.2214 42.8712C83.6308 42.3609 83.665 41.6451 83.3062 41.0982L81.896 38.9485C81.0937 37.7255 82.3252 36.1903 83.6932 36.7082L86.0975 37.6184C86.7093 37.85 87.4006 37.6613 87.8099 37.1511L89.4185 35.1457Z",
    fill: "#D7E6F3",
    fillOpacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5193 9.55549C55.4346 8.4145 57.2752 9.11131 57.2054 10.5724L56.8987 16.9908C56.8675 17.6442 57.2606 18.2434 57.8724 18.475L63.8819 20.75C65.2499 21.2679 65.1559 23.2337 63.7448 23.6188L57.5458 25.3106C56.9147 25.4828 56.4663 26.0418 56.4351 26.6952L56.1284 33.1136C56.0586 34.5747 54.16 35.0928 53.3577 33.8698L49.8331 28.4969C49.4743 27.95 48.8041 27.6962 48.173 27.8685L41.974 29.5602C40.5629 29.9453 39.4834 28.2997 40.3986 27.1587L44.4194 22.1464C44.8287 21.6361 44.8629 20.9203 44.5041 20.3734L40.9795 15.0005C40.1772 13.7774 41.4087 12.2423 42.7767 12.7601L48.7862 15.0352C49.398 15.2668 50.0893 15.0781 50.4986 14.5679L54.5193 9.55549Z",
    fill: "#D7E6F3",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_7038_16864",
    x: 38.5732,
    y: 69.2942,
    width: 54.48,
    height: 29.5477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.0846
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7038_16864"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_7038_16864",
    x: 38.5725,
    y: 69.2969,
    width: 54.48,
    height: 18.2594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.0846
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7038_16864"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7038_16864",
    x: 0,
    y: 7.21289,
    width: 120.915,
    height: 93.5764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_7038_16864"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_7038_16864_clip_path",
    transform: "translate(0 -7.21289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 8.21289C20.6154 27.6629 49.0129 81.6413 45.6781 86.8946L86.2247 99.7893C83.071 81.134 101.658 50.3176 119.915 12.1639L1 8.21289Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7038_16864",
    x1: 72.2146,
    y1: 60.0379,
    x2: 120.47,
    y2: 42.7332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353972,
    stopColor: "#BFD7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554518,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD7EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7038_16864",
    x1: 102.458,
    y1: 87.7308,
    x2: 81.6033,
    y2: 39.5879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7038_16864",
    x1: 79.1059,
    y1: 92.9816,
    x2: 130.815,
    y2: 88.9763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353972,
    stopColor: "#BFD7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554518,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD7EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7038_16864",
    x1: 65.19,
    y1: 89.7772,
    x2: 69.0015,
    y2: 70.0465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7038_16864",
    x1: 38.3631,
    y1: 75.5105,
    x2: 92.1986,
    y2: 86.5818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461538,
    stopColor: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7038_16864",
    x1: 41.5737,
    y1: 4.79451,
    x2: 60.4576,
    y2: 97.6967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#ECF3F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7038_16864",
    x1: 95.1721,
    y1: 81.4946,
    x2: 63.8508,
    y2: 141.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970565,
    stopColor: "#BFD7EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventBoardPage);
export default __webpack_public_path__ + "static/media/event-board-page.f92b8d24118a3aa2e1fdda3a530e6290.svg";
export { ForwardRef as ReactComponent };